import { GET, POST, PUT, DELETE } from "../../../api";

export const findAll = async (
  currentPage,
  perPage,
  name,
  search,
  searchDateFrom,
  searchDateTo,
  id
) => {
  return await GET(
    `/admin/titli_soorat/titli_history?page=${currentPage || 1}&term=${name || ""}&per_page=${perPage || 10}&name=${search || ""
    }&from=${searchDateFrom || ""}&to=${searchDateTo || ""}&id=${id || ""}`
  );
};


export const getSummaryData = async (
  search,
) => {
  return await GET(
    `/admin/titli_soorat/summary_data?name=${search || ""}`
  );
};

export const Create = async (data) => {
  return await POST(`/admin/titli_soorat/titli_history`, data);
};


export const AddRemovePoints = async (id, data) => {
  return await POST(`/admin/titli_soorat/titli_history/add-remove-points/${id}`, data);
};

export const Status = async (id, data) => {
  return await POST(`/admin/titli_soorat/titli_history/${id}`, data);
};
